import maxstache from '../utils/maxstache';
import mitt from 'mitt';
import Sound from './sound';

export default class Player {
  constructor(template) {
    // a non-standard way to "extend" from mitt
    Object.assign(this, mitt());

    // internal properties
    this._activeId = null;
    this._interval = null;
    this._isMuted = false;
    this._template = template;
    this._ext = this._determineCodec();

    // public properties
    this.activeSound = null;
    this.sounds = {};
  }

  play(id) {
    let currentSound;

    if (id == null) {
      currentSound = this.activeSound;
    } else if (this.sounds[id]) {
      currentSound = this.sounds[id];
    } else {
      currentSound = new Sound(this._compileTemplate(id));

      currentSound.on('play', () => {
        clearInterval(this._interval);

        this._interval = setInterval(() => {
          this._tick();
        }, 650);

        this.emit('play', { id, currentSound });
      });

      currentSound.on('stopped', () => {
        clearInterval(this._interval);
        this.emit('stopped', { id, currentSound });
      });

      currentSound.on('ended', () => {
        clearInterval(this._interval);
        this.emit('ended', { id, currentSound });
      });

      this.sounds[id] = currentSound;
    }

    if (id) this._activeId = id;
    this.activeSound = currentSound;

    this._forEachSound(sound => {
      if (sound !== currentSound) sound.stop(true);
    });

    currentSound.mute(this._isMuted);
    currentSound.play();
  }

  stop() {
    if (!this.activeSound) return;

    this.activeSound.stop();
    this.emit('stop');
  }

  pause() {
    if (!this.activeSound) return;

    this.activeSound.pause();
  }

  mute() {
    if (this.activeSound) this.activeSound.mute(true);

    this._isMuted = true;
    this.emit('mute');
  }

  unmute() {
    if (this.activeSound) this.activeSound.mute(false);

    this._isMuted = false;
    this.emit('unmute');
  }

  restart() {
    if (!this.activeSound) return;

    this.activeSound.restart();
    this.emit('restart', {
      id: this._activeId,
      currentSound: this.activeSound,
    });
  }

  get isPlaying() {
    return this.activeSound.isPlaying;
  }

  get isPaused() {
    return this.activeSound.isPaused;
  }

  get isDone() {
    return this.activeSound.isDone;
  }

  get isMuted() {
    return this._isMuted;
  }

  _forEachSound(fn) {
    for (const sound in this.sounds) {
      if (this.sounds.hasOwnProperty(sound)) {
        fn(this.sounds[sound]);
      }
    }
  }

  _tick() {
    const { duration, position } = this.activeSound.seek();
    this.emit('tick', { duration, position });
  }

  _compileTemplate(id) {
    return maxstache(this._template, { id, ext: this._ext });
  }

  _determineCodec() {
    let audioTest = null;

    // Must wrap in a try/catch because IE11 in server mode throws an error.
    try {
      audioTest = typeof Audio !== 'undefined' ? new Audio() : null;
    } catch (err) {
      throw new Error('Cannot determine the appropriate codec to use');
    }

    if (!audioTest || typeof audioTest.canPlayType !== 'function') {
      throw new Error('Audio does not have canPlayType, which is weird.');
    }

    if (audioTest.canPlayType('audio/webm')) {
      return 'webm';
    } else if (audioTest.canPlayType('audio/mpeg')) {
      return 'mp3';
    } else {
      throw new Error('No needed codecs are supported.');
    }
  }
}



// WEBPACK FOOTER //
// ./components/player.js